import { fetchAvailableForAppearancesIn } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { IAvailableForAppearancesIn } from '../../../api/base/Auth/types';

export type IState = IListState<IAvailableForAppearancesIn>;

const initialState: IState = { ...initialListState };

const slice = getListSlice({
  moduleName: 'availableForAppearancesIn',
  fetchDataThunk: fetchAvailableForAppearancesIn,
  initialState,
});

export const availableForAppearancesInReducer = slice.reducer;
